import { Sentry } from "@/helpers/sentry";
import { useSessionStore } from "@/stores/sessionStore";

class Logger {
    static captureMessage(message) {

        if (message === undefined || message === null) {
            return false;
        }

        if (typeof message !== 'string') {
            message = message.toString()
        }

        Sentry.setTag("hubsynch_id", useSessionStore().session_data.hubsynch_id ?? null);
        Sentry.captureMessage(message);
    }
}

export default Logger;
